import * as Util from '../utils/App'

/** アプリケーション定数モジュール */

// *****************************************************************
// 共通
// *****************************************************************

/** WebStorageキー */
export const STORAGE_KEY = {
  USER_INFO: 'userInfo',
  SPACE_TREE: 'spaceTree',
  PLANNING: 'planning',
  PLAN_SEARCH: 'planSearch',
  PLAN_DISP: 'planDisp',
  PROPERTY_SEARCH: 'propertySearch',
  PROPERTY_DISP: 'propertyDisp',
  TRANSITION_URL_NAME: 'transitionURLName'
}

/** dcStorageキー */
export const DC_STORAGE_KEY = {
  USER_INFO: 'dcUserInfo',
  TOP_FORM: 'topForm',
  SAVE_PLAN: 'savePlan',
  CORP_DATA: 'corpData',
  USER_DATA: 'userData',
  ACCOUNT_DATA: 'accountData',
  PASSWORD_DATA: 'passwordData',
  PRICE_DATA: 'priceData',
  STRUCT_DATA: 'constructData',
  DELIVERY_DATA: 'deliveryData',
  ORDER_DATA: 'orderData',
  SUPPORT_DATA: 'supportData',
  USER_IS_EDIT: 'userEdit',
  SEL_BUSINESS: 'selBusiness',
  PAGE_LIST: 'pageList',
  UPDATE_USER: 'updateUser',
  PREF_RESEARCH: 'prefResearch',
  RESEARCH_CHECKED: 'researchChecked',
  RESEARCH_DATA: 'researchData',
  INVITE_CODE: 'invateCode',
  ORDER_SEARCH: 'orderSearch',
  ORDER_DISP: 'orderDisp',
  ORDER_LIST_DATA: 'orderListData',
  PROFIT_FLAG: 'profitFlag',
  SELECT_PLAN: 'selectPlan',
  PAYMENT_TYPE: 'paymentType',
  USER_TYPE: 'userType',
  GUEST_USER_INFO: 'guestInfo',
  SKETCH_ORDER: 'sketchOrder',
  PRODUCT_SEARCH: 'productSearch',
  SAVE_PRODUCT_SEARCH: 'saveProductSearch'
}

/** KgStorageキー */
export const KG_STORAGE_KEY = {
  USER_INFO: 'kgUserInfo',
  PASSWORD_DATA: 'passwordData',
  SELECT_CATEGORY_DATA: 'selectCategoryData',
  SELECT_STYLE_DATA: 'selectStyleData',
  SELECT_PLAN_DATA: 'selectPlanData',
  SIZE_DATA: 'sizeData',
  CONTACT_DATA: 'contactData',
  SELECT_NEWS_DATA: 'selectNewsData',
  ORDER_INFO: 'orderInfo',
  ORDER_INPUT: 'orderInput',
  OPTION_SERVICE_LIST: 'optionServiceList'
}

/** キーコード */
export const KEY_CODE = {
  ENTER: 13,
  ESC: 27,
  SPACE: 32,
  DELETE: 46,
  C: 67,
  N: 78,
  P: 80,
  S: 83,
  V: 86,
  Y: 89,
  Z: 90,
  A: 65
}

/** マウスボタン */
export const MOUSE_BUTTON = {
  LEFT: 0,
  MIDDLE: 1,
  RIGHT: 2,
  UNDEFINED: null
}

/** カラム種別 */
export const COLUMN_TYPE = {
  INT: 'int',
  BIGINT: 'bigint',
  DOUBLE: 'double',
  DATETIME: 'datetime'
}

/** カラム名 */
export const COLUMN_NAME = {
  CORP_ID: 'c_corp_id'
}

// *****************************************************************
// WEB API
// *****************************************************************
/** WEB API：ホスト */
const API_HOST = location.protocol + '//' + location.hostname + (Util.isLocal() ? ':8080' : '')
/** WEB API：エンドポイント */
const API_ENDPOINT = '/api/web'
/** WEB API DC */
const API_DC = '/mmstyle'
/** WEB API KG */
const API_KG = '/kagull'
/** WEB API：URL */
const api = (url) => API_HOST + API_ENDPOINT + '/' + url
/** WEB DC：URL */
const dc = (url) => API_HOST + API_ENDPOINT + API_DC + '/' + url
/** WEB KG：URL */
const kg = (url) => API_HOST + API_ENDPOINT + API_KG + '/' + url

/** API API：URL */
export const API_URL = {
  ADMIN: api('admin'),
  LOGIN: api('login'),
  LOGOUT: api('logout'),
  PASSWORD: api('password'),
  TOP: api(''),
  INIT: api('init'),
  UNIT: api('unit'),
  PLANNING: api('planning'),
  COMMAND: api('command'),
  MASTER: api('master'),
  UPLOAD: api('upload'),
  PREVIEW: api('preview'),
  OUTPUT: api('output'),
  ORDER: api('order'),
  PROPERTY: api('property'),
  SUPPORT: api('support'),
  PRESENTATION: api('presentation-sheet'),
  LIST: api('list'),
  CONTENTS_DATA: api('contentsdata')
}

export const DC_URL = {
  TOP: dc('top'),
  LOGIN: dc('login'),
  USER: dc('user'),
  ORDER: dc('order'),
  SUPPORT: dc('support'),
  SHEET: dc('sheet'),
  RESEARCH: dc('research'),
  PASSWORD: dc('password'),
  SAVE: dc('save'),
  SCHEDULE: dc('schedule'),
  CART: dc('cart'),
  PRODUCT: dc('product'),
  SKETCH: dc('sketch')
}

export const KG_URL = {
  TOP: kg('top'),
  USER: kg('user'),
  PLANNING: kg('planning'),
  ORDER: kg('order'),
  SUPPORT: kg('support'),
  SHEET: kg('sheet'),
  RESEARCH: kg('research'),
  PASSWORD: kg('password'),
  SAVE: kg('save'),
  SCHEDULE: kg('schedule'),
  SURVEY: kg('survey'),
  MYPAGE: kg('mypage')
}

/** URL判定 */
export const PTN_DC = new RegExp('^.*/#/.*mmstyle.*')
export const PTN_KG = new RegExp('^.*kagull.*')
export const PTN_KG_SHEET = new RegExp('^.*sheet.*')
export const PTN_DAROS_OUTPUT = new RegExp('^.*output.*')
/**  */
export const STRUCT_CORP_ID_ST = 99990
export const STRUCT_CORP_ID_ED = 99999

// *****************************************************************
// プランニング
// *****************************************************************
/** 図形選択幅 */
export const SELECT_RANGE_DEFAULT = 30
/** 図形吸着距離 */
export const SNAP_DIST = 40
/** SVG最大値 */
export const SVG_MAX_VALUE = 1.0e+7
/** SVG拡大率初期値 */
export const SVG_ZOOM_RATIO_DEFAULT = 3.0
/** SVG拡大率最小値 */
export const SVG_ZOOM_RATIO_MIN = 0.01
/** SVG拡大速度 */
export const SVG_ZOOM_SPEED = [
  { threshold: 1.0, speed: 0.5 },
  { threshold: 0.1, speed: 0.1 },
  { threshold: -SVG_MAX_VALUE, speed: 0.01 }
]
/** SVG寸法値表示間隔 */
export const SVG_DIM_PITCH = [
  { threshold: 20, pitch: 10000 },
  { threshold: 2, pitch: 1000 },
  { threshold: 0.1, pitch: 100 },
  { threshold: -SVG_MAX_VALUE, pitch: 10 }
]
/** SVGグリッド線表示制御 */
export const SVG_GRID = [
  { pitch: 1, threshold: 0.1, strokeWidth: 0.5 },
  { pitch: 10, threshold: 1, strokeWidth: 1 },
  { pitch: 100, threshold: 15, strokeWidth: 1 },
  { pitch: 1000, threshold: SVG_MAX_VALUE, strokeWidth: 2 }
]
/** グラフ表示範囲の最小XYの初期値 */
export const SVG_MIN_DEFAULT = -100
/** SVG最小フォントサイズ */
export const SVG_FONT_SIZE = 12
/** 小数点以下桁数 */
export const DECIMAL_DIGIT = 3
/** ビューサイズ最小値 */
export const VIEW_SIZE_MIN = 100
/** TOP画面 重要情報最大表示数 */
export const NOTICE_IMP_MAX_COUNT = 2
/** TOP画面 新着情報最大表示数 */
export const NOTICE_LATEST_MAX_COUNT = 4
/** TOP画面 お知らせ最大表示数 */
export const NOTICE_INFO_MAX_COUNT = 4

/** 表示線種類 */
// 実線・点線のみ対応済み。その他線種類は未実装。
export const LINE_TYPE = {
  SOLID_1: { value: '0' },
  DOTTED_2: { value: '5' },
  DOTTED_3: { value: '20 10' }
}
/** 表示線制御 */
export const SVG_LINE = {
  // 軸線
  AXIS_LINE: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 3.0 },
  // グリッド線（太さはSVG_GRIDで指定）
  GRID_LINE: { color: 'gray', dasharray: LINE_TYPE.SOLID_1.value, width: 0 },
  // 扉開閉線
  DOOR_OPEN: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 1.0 },
  // 隠れた空間
  HIDDEN_SPACE: { color: 'black', dasharray: LINE_TYPE.DOTTED_2.value, width: 2.0 },
  // 編集空間
  EDIT_SPACES: { color: 'coral', dasharray: LINE_TYPE.DOTTED_3.value, width: 2.0 },
  // 空間グループ
  GROUP_CTRL_SPACES: { color: 'coral', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 追加予定位置
  LOCATE_ADD_SPACE: { color: 'coral', dasharray: LINE_TYPE.DOTTED_3.value, width: 2.0 },
  // 上書き対象空間
  TARGET_SWAP_SPACE: { color: 'coral', dasharray: LINE_TYPE.SOLID_1.value, width: 5.0 },
  // 表面オプション配置対象空間
  TARGET_FACEOP_ADD_SPACE: { color: 'coral', dasharray: LINE_TYPE.SOLID_1.value, width: 5.0 },
  // 追加
  ADD_CTRL_SPACE: { color: 'coral', dasharray: LINE_TYPE.DOTTED_3.value, width: 2.0 },
  // 強調線
  FOCUS_SPACE: { color: 'coral', dasharray: LINE_TYPE.SOLID_1.value, width: 5.0 },
  // 吸着線
  SNAP_LINES: { color: 'red', dasharray: LINE_TYPE.SOLID_1.value, width: 5.0 },
  // 断面線
  SECTION_LINES: { color: 'mediumaquamarine', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 図面断面線
  SECTION_POINT_LINES: { color: 'green', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 面選択線(選択中)
  FACE_LINES_BEFORE: { color: 'tomato', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 面選択線(決定後)
  FACE_LINES_AFTER: { color: 'tomato', dasharray: LINE_TYPE.SOLID_1.value, width: 5.0 },
  // 矩形選択
  SELECT_AREA: { color: '#68c2c3', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 位置ガイド線
  POSITION_GUIDE: { color: '#ff4500', dasharray: LINE_TYPE.SOLID_1.value, width: 1.0 },
  // 可動棚線
  INFILL_LINE: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 1.0 },
  // パーツ
  PARTS: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // コンバイン
  COMBINE: { color: 'mediumblue', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // ユニット
  UNIT: { color: 'dodgerblue', dasharray: LINE_TYPE.SOLID_1.value, width: 1.0 },
  // 素材
  ELEMENT: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 0.5 },
  // ユニットコンポーネント
  UNITCOMPONENT: { color: 'aqua', dasharray: LINE_TYPE.SOLID_1.value, width: 0.5 },
  // セル
  CELL: { color: 'gold', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 選択中セル
  SELECT_CELL: { color: 'gold', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 金具
  FITTING: { color: 'blueviolet', dasharray: LINE_TYPE.SOLID_1.value, width: 0.5 },
  // 加工
  PROCESS: { color: 'saddlebrown', dasharray: LINE_TYPE.SOLID_1.value, width: 0.5 },
  // 編集中加工
  TARGET_PROCESS: { color: 'red', dasharray: LINE_TYPE.SOLID_1.value, width: 5.0 },
  // セットプラン
  SETPLAN: { color: '#008080', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // ルーム
  ROOM: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 5.0 },
  // 空間断面線
  SPACE_SECTION: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // アクセサリー
  ACCESSORY: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 2.5 },
  // 指定なし
  DEFAULT: { color: 'black', dasharray: LINE_TYPE.SOLID_1.value, width: 1.0 }
}

// *****************************************************************
// mmstyle 設定
// *****************************************************************
/** prpic画像のON */
export const DC_PRPIC_ON = 0
/** テスト用にpaygentをskipする */
export const DC_PAYGENT_SKIP_ON = 0

// *****************************************************************
// カグル図面
// *****************************************************************
/** SVG拡大率最小値 */
export const KG_SVG_ZOOM_RATIO_MIN = 0.3
/** SVG拡縮無効範囲 */
export const KG_SVG_ZOOM_INVALID_RANGE = {
  min: 0.8,
  max: 1.2
}
/** SVG移動倍率 */
export const KG_SVG_MOVE_MAGNIFICATION = 4



// WEBPACK FOOTER //
// ./src/main/js/constants/App.js